var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.descriptionText)?_c('div',{staticClass:"ques-des"},[_vm._v(" "+_vm._s(_vm.descriptionText)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }